module.exports = __webpack_public_path__ + "static/media/img-5.dbc69c2d.jpg";